import i18n from "@/i18n";

export const playerFields = [
    {
        key: "status",
        label: ""
    },
    {
        key: "name",
        label: i18n.t("common.name"),
        sortable: true,
        sortDirection: "desc"
    },
    {
        key: "playerId",
        label: i18n.t("player.id")
    },

    {
        key: "actions",
        label: ""
    },
    {
        key: "drag",
        label: "",
        class: "draggable-btn-cell"
    }
];
